module.exports = __webpack_public_path__ + "static/pakmaya-web-cf646051c797b72e8eddc0b8f243efcc.jpg";